import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import ContactsIcon from '@mui/icons-material/Contacts';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const B = { primary: '#4357AD', dark: '#1E2A4A' };

const InfoItem = ({ icon, label, value }) => (
  <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flex: 1, minWidth: 0 }}>
    <Box sx={{ width: 36, height: 36, borderRadius: 2, bgcolor: '#EDE9FE', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      {icon}
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" sx={{ color: '#8891A5', fontWeight: 500 }}>{label}</Typography>
      <Typography variant="body2" fontWeight={600} sx={{ color: B.dark }} noWrap>{value || '—'}</Typography>
    </Box>
  </Stack>
);

const StudentInfoCard = ({ student, summary }) => {
  if (!student) return null;

  return (
    <Card sx={{ borderRadius: 4, boxShadow: '0 1px 6px rgba(0,0,0,0.04)', bgcolor: '#fff' }}>
      <CardContent sx={{ py: 2.5 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          sx={{
            flexWrap: 'wrap',
            gap: 2,
            '& > *': { flex: { xs: '1 1 100%', sm: '1 1 0' }, minWidth: { sm: 150 } },
          }}
        >
          <InfoItem icon={<PersonIcon sx={{ fontSize: 18, color: '#22C55E' }} />} label="Репетитор" value={student.tutorName} />
          <InfoItem icon={<ContactsIcon sx={{ fontSize: 18, color: '#F59E0B' }} />} label="Батьки / контакти" value={student.parentContact || student.parentName} />
          {summary && (
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flex: 1, minWidth: 150 }}>
              <Box sx={{ width: 36, height: 36, borderRadius: 2, bgcolor: '#D1FAE5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <AccountBalanceWalletIcon sx={{ fontSize: 18, color: '#22C55E' }} />
              </Box>
              <Box>
                <Typography variant="caption" sx={{ color: '#8891A5', fontWeight: 500 }}>Баланс</Typography>
                <Stack direction="row" spacing={0.5} sx={{ mt: 0.25 }}>
                  <Chip label={`Залишок: ${summary.remainingCredits}`} size="small" sx={{ bgcolor: '#D1FAE5', color: '#166534', fontWeight: 600, fontSize: 12, height: 22 }} />
                  <Chip
                    label={`Борг: ${summary.debtLessons}`}
                    size="small"
                    sx={{ bgcolor: summary.debtLessons > 0 ? '#FEE2E2' : '#F1F5F9', color: summary.debtLessons > 0 ? '#DC2626' : '#64748B', fontWeight: 600, fontSize: 12, height: 22 }}
                  />
                </Stack>
              </Box>
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default StudentInfoCard;
